export default defineNuxtRouteMiddleware((to) => {
  if (!useDevice().isMobile) {
    to.meta.pageTransition = false;
    return;
  }

  const navigationDirection = useNavigationDirection();

  to.meta.pageTransition = {
    name:
      navigationDirection.value === "back"
        ? "page-slide-back"
        : "page-slide-forward",
    mode: "in-out",
  };
});
